<template>
<div class="chapter">
<div class="inner_page">
<p class="C134"><strong><a id="page_vii">CONTENTS</a></strong></p><a id="page_vii">
</a><p class="C135"><a id="page_vii"><em></em></a><em><a href="#/xhtml/06_List_of#page_ix">List of Illustrations</a></em></p>
<p class="C135"><em><a href="#/xhtml/07_Acknowle#page_xi">Acknowledgments</a></em></p>
<p class="C135"><a href="#/xhtml/08_Introduc#page_1">Introduction</a></p>
<p class="C135"><a href="#/xhtml/09_1__The_L#page_21">1. The Logic of Political Monopolies</a></p>
<p class="C135"><span href="#/xhtml/10_2__Found#page_42" title="Link target outside of Sample">2. Foundations of Political Monopolies</span></p>
<p class="C135"><span href="#/xhtml/11_3__Coord#page_62" title="Link target outside of Sample">3. Coordinating Monopolies</span></p>
<p class="C135"><span href="#/xhtml/12_4__Estab#page_107" title="Link target outside of Sample">4. Establishing Political Monopolies</span></p>
<p class="C135"><span href="#/xhtml/13_5__Effec#page_139" title="Link target outside of Sample">5. Effects of Political Monopolies</span></p>
<p class="C135"><span href="#/xhtml/14_6__Monop#page_172" title="Link target outside of Sample">6. Monopoly Collapse</span></p>
<p class="C135"><span href="#/xhtml/15_7__The_R#page_217" title="Link target outside of Sample">7. The Rise and Fall of Bosses and Reformers</span></p>
<p class="C135"><em><span href="#/xhtml/16_Appendix#page_237" title="Link target outside of Sample">Appendix</span></em></p>
<p class="C135"><em><span href="#/xhtml/17_Notes#page_245" title="Link target outside of Sample">Notes</span></em></p>
<p class="C135"><em><span href="#/xhtml/18_Referenc#page_261" title="Link target outside of Sample">References</span></em></p>
<p class="C135"><em><span href="#/xhtml/19_Index#page_279" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?6ed0f4bc